<div class="counter-row" [class.counter-row--disabled]="disabledState()">
  <div class="counter-row__label">
    @if (icon(); as iconName) {
      <sui-icon
        class="counter-row__icon"
        size="md"
        [name]="iconName"
      ></sui-icon>
    }
    <span class="counter-row__text" [id]="controlName + '-label'">
      {{ label() | translate }}
    </span>
  </div>

  <div class="counter-row__stepper">
    @if (editable()) {
      <button
        type="button"
        class="counter-row__btn"
        [attr.aria-label]="
          decreaseAriaLabel() | translate: { label: label() | translate }
        "
        [attr.aria-controls]="controlName + '-value'"
        [disabled]="!canDecrease()"
        (click)="decrease()"
      >
        <sui-icon name="minus" size="sm"></sui-icon>
      </button>
    }

    <output
      class="counter-row__value"
      role="spinbutton"
      [attr.aria-labelledby]="controlName + '-label'"
      [attr.aria-valuenow]="currentValue()"
      [attr.aria-valuemin]="min()"
      [attr.aria-valuemax]="max()"
      [attr.aria-disabled]="disabledState() ? 'true' : null"
      [attr.aria-readonly]="!editable() || disabledState() ? 'true' : null"
      [attr.tabindex]="editable() && !disabledState() ? 0 : -1"
      [id]="controlName + '-value'"
      (keydown)="onKeydown($event)"
    >
      {{ currentValue() }}
    </output>

    @if (editable()) {
      <button
        type="button"
        class="counter-row__btn"
        [attr.aria-label]="
          increaseAriaLabel() | translate: { label: label() | translate }
        "
        [attr.aria-controls]="controlName + '-value'"
        [disabled]="!canIncrease()"
        (click)="increase()"
      >
        <sui-icon name="plus" size="sm"></sui-icon>
      </button>
    }
  </div>
</div>
